import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import * as fromContainers from './containers';
import { NotificationModule } from 'libraries/component/notification/notification.module';
import { ROUTES } from './routes';
import { BookingResourceModule } from "libraries/service/resources/booking/bookingResource.module";
import { BookingInformationModule } from "libraries/component/booking-information/booking-information.module";
import { TableServicesServiceModule } from "libraries/component/booking-information/components/sectors/components/shared/services/table-services/table-services.module";
import { EnumsResourceModule } from "libraries/service/booking/enums/enums-resource.module";
import { HotelResourceModule } from "libraries/service/resources/hotel/hotelResource.module";
import { UrlHelperModule } from "libraries/service/url-helper/url-helper.module";
import { BookingDomainService } from "app_iaqobohotel/booking-page/containers/booking/services/booking-domain.service";
import { LocalizedModule } from "libraries/pipes/localized/localized.module";

@NgModule({
    imports: [
        CommonModule,
        NotificationModule,
        RouterModule.forChild(ROUTES),
        BookingResourceModule,
        BookingInformationModule,
        TableServicesServiceModule,
        EnumsResourceModule,
        HotelResourceModule,
        UrlHelperModule,
        LocalizedModule,
    ],
    declarations: [
        ...fromContainers.containers,
    ],
    exports: [
        ...fromContainers.containers,
    ],
    providers: [
        BookingDomainService,
    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA,
    ]
})
export class BookingPageModule { }
